import { mst } from 'reactotron-mst'
import Reactotron from 'reactotron-react-js'

import { Consts } from '@/configs/consts'

export function setupReactotron() {
  if (Consts.isDev) {
    console.tron = Reactotron.configure({ name: 'Sidekick Portal' }).use(mst()).connect()
  }
}
